import React from 'react';

const EducationSummary = () => {
    return (
        <section className="education-summary">
            <h6 className="heading-small">
                <span>Education</span>
            </h6>
            <div className="section-content">
                <div className="row m-0">
                    <div className="education-duration">
                        <span className="sub-heading d-block">2010 - '15</span>
                    </div>
                    <div className="col">
                        <span className="sub-heading d-block">Bachelor of Engineering ( Computer Science )</span>
                        <span className="sub-heading d-block institution-name grey-text text-darken-1">University of Pune</span>
                        <p className="education-details">
                            {/* <span>Graduated with "Higher Second Class"</span> */}
                        </p>
                    </div>
                </div>
                <div className="row m-0">
                    <div className="education-duration">
                        <span className="sub-heading d-block">2008 - '10</span>
                    </div>
                    <div className="col">
                        <span className="sub-heading d-block">Higher Secondary Education [67.67%]</span>
                        <span className="sub-heading d-block institution-name grey-text text-darken-1">Maharashtra State Board</span>
                        <p className="education-details">
                        </p>
                    </div>
                </div>
                <div className="row m-0">
                    <div className="education-duration">
                        <span className="sub-heading d-block">May 2008</span>
                    </div>
                    <div className="col">
                        <span className="sub-heading d-block">Secondary School Certificate [86.15%]</span>
                        <span className="sub-heading d-block institution-name grey-text text-darken-1">Maharashtra State Board</span>
                        <p className="education-details">
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EducationSummary;
